import { graphql } from "msw";

import { PageConfigurationQuery } from "@common-vendors/generated/graphql";
import { mockPageConfig } from "@common-vendors/mocks/data";

export const handler = graphql.query<PageConfigurationQuery>(
  "PageConfiguration",
  (_req, res, ctx) => {
    return res(
      ctx.data({
        __typename: "Query" as const,
        cmsConfiguration: {
          __typename: "CMSConfiguration" as const,
          page: mockPageConfig,
        },
      })
    );
  }
);
